module.exports = __webpack_public_path__ + "img/global-code_expired.png?765f376b";